import { Component, inject, input } from "@angular/core";
import { ButtonComponent } from "@husbanken/designsystem-angular-core";
import { QlikService } from "../../services/qlik.service";

@Component({
  selector: "stat-downloaddatasett",
  templateUrl: "./downloaddatasett.component.html",
  imports: [ButtonComponent],
})
export class DownloaddatasettComponent {
  private qlikService = inject(QlikService);

  public readonly title = input<string>();
  public readonly rader = input(undefined);
  public readonly omDataGrunnlaget = input<string>();
  public readonly dokumentasjon = input(undefined);

  public visDatagrunnlagUtvidet = false;
  public formatCsv = false;
  public lasterData = false;
  public lastFeilet = false;

  public downloaddatasett(format: string, objekt: string, tilstand: string, virkemiddel: string) {
    if (!this.lasterData) {
      this.qlikService.setFilter("VirkemiddelKode", virkemiddel, false, true);
      this.qlikService.setFilter("TypeTilstand", tilstand, false, true);

      this.showDownloadMessage();

      if (this.formatCsv) {
        this.qlikService.saveAsCsv(objekt, undefined, err => {
          this.onSaveDone(err);
        });
      } else {
        this.qlikService.saveAsExcel(objekt, undefined, err => {
          this.onSaveDone(err);
        });
      }
    }
  }

  /* Callback funksjon fra saveExportData */
  public onSaveDone(error: unknown) {
    if (error != null) {
      this.lastFeilet = true;
      console.error("Error respons" + error);
    }
    this.showDownloadMessage();
  }

  public setFormatCsv() {
    this.formatCsv = !this.formatCsv;
  }

  public showDownloadMessage() {
    this.lasterData = !this.lasterData;
  }

  public downloadDocumentation() {
    window.open(this.dokumentasjon(), "_blank");
  }
}
